export default "__VITE_ASSET__BGp0KgGt__";